import { React } from 'react';
import TViewTicker from './TViewTicker'

  
function Hero() {


    return (
        <div className="section overflow-hidden">
            <div className="container">
                <TViewTicker/>
                <div className="center-text">
                    <div className="hero-text-holder">
                        <div className="animate-on-load-1st">
                            <div className="hero-text"><span className="gradient-text">Transform</span> Data into Decisions</div>
                        </div>
                        <div className="animate-on-load-2st">
                            <div className="paragraph-hero">
                                <p className="paragraph">Discover the Strength of Currencies and the Pulse of Markets. From Insight to Impact: Trade with Market-Proven Intelligence</p>
                            </div>
                        </div>
                        <div className="animate-on-load-3rd">
                            <div className="hero-button-holder">
                                <a href="#More" className="gradient-link w-inline-block">
                                    <div className="link-gradient-text">Learn More</div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="animate-on-load-4rd">
                    <div className="app-holder">
                        <div className="app-container">
                            <div className="app-main-photo"><img src="/assets/images/Assets_CS_DivAlerts-2.jpg" loading="lazy" sizes="(max-width: 479px) 89vw, (max-width: 767px) 88vw, (max-width: 991px) 75vw, (max-width: 1439px) 76vw, 1035.1875px" srcSet="/assets/images/Assets_CS_DivAlerts-2-p-500.jpg 500w, /assets/images/Assets_CS_DivAlerts-2-p-800.jpg 800w, /assets/images/Assets_CS_DivAlerts-2-p-1080.jpg 1080w, /assets/images/Assets_CS_DivAlerts-2-p-1600.jpg 1600w, /assets/images/Assets_CS_DivAlerts-2-p-2000.jpg 2000w, /assets/images/Assets_CS_DivAlerts-2-p-2600.jpg 2600w, /assets/images/Assets_CS_DivAlerts-2-p-3200.jpg 3200w, /assets/images/Assets_CS_DivAlerts-2.jpg 3840w" alt="" className="app-photo"/></div>
                            <div className="app-info-01"><img src="/assets/images/SmartMoney_PieChart.jpg" loading="lazy" sizes="(max-width: 479px) 100px, (max-width: 991px) 150px, 250px" srcSet="/assets/images/SmartMoney_PieChart-p-500.jpg 500w, /assets/images/SmartMoney_PieChart-p-800.jpg 800w, /assets/images/SmartMoney_PieChart-p-1080.jpg 1080w, /assets/images/SmartMoney_PieChart-p-1600.jpg 1600w, /assets/images/SmartMoney_PieChart.jpg 1935w" alt="" className="_100width"/></div>
                            <div className="app-info-02"><img src="/assets/images/SmartMoney_Predyctx.jpg" loading="lazy" sizes="(max-width: 767px) 180px, (max-width: 991px) 280px, 506px" srcSet="/assets/images/SmartMoney_Predyctx-p-500.jpg 500w, /assets/images/SmartMoney_Predyctx-p-800.jpg 800w, /assets/images/SmartMoney_Predyctx-p-1080.jpg 1080w, /assets/images/SmartMoney_Predyctx-p-1600.jpg 1600w, /assets/images/SmartMoney_Predyctx-p-2000.jpg 2000w, /assets/images/SmartMoney_Predyctx-p-2600.jpg 2600w, /assets/images/SmartMoney_Predyctx-p-3200.jpg 3200w, /assets/images/SmartMoney_Predyctx.jpg 4320w" alt="" className="_100width"/></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Hero;